import { MapPin, Phone, Mail } from 'lucide-react';
import { COMPANY, NAV_LINKS, PRODUCTS } from '../../data/site';

export const Footer = () => (
  <footer data-testid="footer" className="bg-forest-deep text-cream">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p data-testid="footer-brand" className="font-display text-3xl font-semibold tracking-tight">
            SKycodeX <span className="accent-italic">AgroTech</span>
          </p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-cream/60">
            Quality agricultural products from India, prepared for global trade.
          </p>
          <p className="mt-6 inline-block rounded-full border border-cream/20 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.26em] text-gold-soft">
            {COMPANY.tagline}
          </p>
        </div>

        <div className="lg:col-span-2">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold-soft">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-cream/70 transition-colors hover:text-gold-soft"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold-soft">Products</p>
          <ul className="mt-5 space-y-3">
            {PRODUCTS.map((p) => (
              <li key={p.id}>
                <a href="#products" data-testid={`footer-product-${p.id}`} className="text-sm text-cream/70 transition-colors hover:text-gold-soft">
                  {p.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold-soft">Contact</p>
          <ul className="mt-5 space-y-4 text-sm text-cream/70">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-soft" />
              <span>{COMPANY.location}</span>
            </li>
            <li>
              <a href={`tel:${COMPANY.phoneRaw}`} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-gold-soft">
                <Phone className="h-4 w-4 shrink-0 text-gold-soft" />
                <span>{COMPANY.phone}</span>
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email-link" className="flex items-center gap-3 transition-colors hover:text-gold-soft">
                <Mail className="h-4 w-4 shrink-0 text-gold-soft" />
                <span>{COMPANY.email}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-cream/15 pt-8 sm:flex-row">
        <p className="text-xs text-cream/50">© 2026 SKycodeX AgroTech. All rights reserved.</p>
        <p className="text-xs text-cream/50">From India to the World</p>
      </div>
    </div>
  </footer>
);

export default Footer;
